export default __webpack_public_path__ + "static/media/cp_geo_mf.d2193fdb.svg";